import { makeStyles } from '@material-ui/core/styles'
import { customColor } from '../../../../../../theme/theme'

export const parkingNotificaionsStyles = makeStyles((theme) => ({
  parkingNotificationOverlay: {
    position: 'absolute',
    bottom: '20px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
    textAlign: 'left',
  },
  parkingNotificationContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    width: 300,
    background: customColor.rutgersRed,
    color: theme.palette.base.white,
  },
  parkingLinkContainer: {
    background: 'white',
    padding: '1px 2px',
    marginBottom: '5px',
    borderRadius: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  parkingLink: {
    color: theme.palette.components.linkText,
    padding: '5px',
    '&:hover': {
      color: theme.palette.components.linkText,
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
}))

export default parkingNotificaionsStyles
